(function(){
if(window.__pdpInit)return;window.__pdpInit=1;
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
ready(function(){

/* reveal on scroll, scroll driven with a failsafe so nothing can stay invisible */
var rev=[].slice.call(document.querySelectorAll('.pdp .reveal'));
var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function show(){if(reduced){rev.forEach(function(e){e.classList.add('in')});rev=[];return;}var vh=window.innerHeight||800;rev=rev.filter(function(e){var r=e.getBoundingClientRect();if(r.top<vh*0.92&&r.bottom>-60){e.classList.add('in');return false}return true})}
var tick=false;function onScroll(){if(tick)return;tick=true;requestAnimationFrame(function(){tick=false;show()})}
window.addEventListener('scroll',onScroll,{passive:true});window.addEventListener('resize',onScroll,{passive:true});
show();setTimeout(show,300);setTimeout(show,1200);
setTimeout(function(){document.querySelectorAll('.pdp .reveal:not(.in)').forEach(function(e){e.classList.add('in')})},5000);

/* tickers */
document.querySelectorAll('.pdp .tick-track').forEach(function(t){if(!t.dataset.dup){t.dataset.dup='1';t.innerHTML=t.innerHTML+t.innerHTML+t.innerHTML;}});

/* rotating announcement strips */
document.querySelectorAll('.pdp [data-rotate]').forEach(function(box){
  var items=[].slice.call(box.children);if(items.length<2)return;var i=0;
  setInterval(function(){items[i].classList.remove('on');i=(i+1)%items.length;items[i].classList.add('on');}, parseInt(box.dataset.rotate,10)||4000);
});

/* modals, used by the nutrition label pill */
document.querySelectorAll('.pdp [data-modal-open]').forEach(function(b){
  b.addEventListener('click',function(e){e.preventDefault();var m=document.getElementById(b.getAttribute('data-modal-open'));if(m)m.classList.add('on');});
});
document.querySelectorAll('.pdp-modal').forEach(function(m){
  m.addEventListener('click',function(e){if(e.target===m||e.target.closest('.x'))m.classList.remove('on');});
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('.pdp-modal.on').forEach(function(m){m.classList.remove('on')});}});

/* gallery */
document.querySelectorAll('.pdp [data-gallery]').forEach(function(g){
  var main=g.querySelector('[data-galmain]'),thumbs=g.querySelector('[data-thumbs]'),slides=g.querySelector('[data-slides]');
  if(!main||!thumbs)return;
  var badge=main.getAttribute('data-badge')||'';
  thumbs.addEventListener('click',function(e){
    var b=e.target.closest('button');if(!b)return;
    [].forEach.call(thumbs.children,function(c){c.classList.remove('on')});b.classList.add('on');
    main.innerHTML = badge?'<span class="badge-fda">'+badge+'</span>':'';
    if(b.dataset.type==='slide'&&slides){var tpl=slides.querySelector('.gslide[data-id="'+b.dataset.slide+'"]');if(tpl)main.appendChild(tpl.cloneNode(true));}
    else if(b.dataset.type==='vid'){main.insertAdjacentHTML('beforeend','<video controls autoplay muted playsinline src="'+b.dataset.src+'"></video>');}
    else{main.insertAdjacentHTML('beforeend','<img src="'+b.dataset.src+'" alt="">');}
  });
});

/* buy box: household selector + plan tiers + per day pricing.
   base and days are read live from the dataset on every calculation, so a size
   switcher can change the product under the buy box with no page reload. */
document.querySelectorAll('.pdp [data-buybox]').forEach(function(box){
  var cur=box.dataset.currency||'฿';
  var people=1, plan=box.dataset.defaultPlan||'a';
  var qsel=box.querySelector('[data-qsel]'), plans=box.querySelector('[data-plans]'), cta=box.querySelector('[data-cta]');
  if(!plans)return;
  function money(n){return cur+Math.round(n).toLocaleString('en-US')}
  function calc(el){
    var base=parseFloat(box.dataset.base||'0'), days=parseInt(box.dataset.days||'30',10);
    var disc=parseFloat(el.dataset.discount||'0')/100, mult=parseInt(el.dataset.mult||'1',10);
    var extra=people===2?(1-(parseFloat(box.dataset.pairDiscount||'0')/100)):1;
    var bottles=mult*people, price=base*bottles*(1-disc)*extra, was=base*bottles;
    return {bottles:bottles,price:price,was:was,days:days*mult,perDay:price/(days*mult*people)};
  }
  function render(){
    if(qsel)[].forEach.call(qsel.querySelectorAll('.qbtn'),function(b){b.classList.toggle('on',parseInt(b.dataset.people,10)===people)});
    var active=null;
    plans.querySelectorAll('.plan').forEach(function(el){
      var c=calc(el), on=el.dataset.plan===plan; el.classList.toggle('on',on); if(on)active=c;
      var q=function(s){return el.querySelector(s)};
      if(q('[data-price]'))q('[data-price]').textContent=money(c.price);
      if(q('[data-was]'))q('[data-was]').textContent=c.price<c.was?money(c.was):'';
      if(q('[data-day]'))q('[data-day]').textContent=money(c.perDay)+'/day'+(people===2?' each':'');
      if(q('[data-units]'))q('[data-units]').textContent=c.bottles+(c.bottles>1?' bottles':' bottle')+' · '+c.days+' day supply'+(people===2?' each':'');
      if(q('[data-save]'))q('[data-save]').textContent=money(c.was-c.price);
      var input=el.querySelector('input[type=radio]'); if(input)input.checked=on;
    });
    if(cta&&active){var lbl=cta.dataset.label||'Add to cart';cta.textContent=active.price<active.was?lbl+' · save '+money(active.was-active.price):lbl;}
    var qty=box.querySelector('input[name=quantity]'); if(qty&&active)qty.value=active.bottles;
  }
  if(qsel)qsel.addEventListener('click',function(e){var b=e.target.closest('.qbtn');if(!b)return;e.preventDefault();people=parseInt(b.dataset.people,10);render()});
  plans.addEventListener('click',function(e){var el=e.target.closest('.plan');if(!el)return;plan=el.dataset.plan;render()});
  box.__pdpRender=render;
  render();
});

});
})();
